/* eslint-disable no-unused-vars */
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/boletin.css";
import { supabase } from "../../services/supabaseClient";
import { useBoletin } from "../../context/BoletinContext";

export default function Boletin() {
  const {
    noticias,
    setNoticias,
    recomendaciones,
    setRecomendaciones,
    noticiaDestacada,
    setNoticiaDestacada,
    totalNoticias,
    setTotalNoticias,
    cargando,
    setCargando,
  } = useBoletin();
  const navigate = useNavigate();
  const [loadingDetalle, setLoadingDetalle] = React.useState(false);
  const [pagina, setPagina] = React.useState(1);
  const pageSize = 10;

  React.useEffect(() => {
    // Solo consulta si NO hay datos en contexto
    if (
      noticias.length > 0 &&
      recomendaciones.length > 0 &&
      noticiaDestacada &&
      totalNoticias > 0
    ) {
      setCargando(false);
      return;
    }

    const fetchData = async (paginaActual = 1) => {
      setCargando(true);
      const from = (paginaActual - 1) * pageSize;
      const to = from + pageSize;

      // 1. Obtener noticia destacada
      let { data: noticiaDestacadaData } = await supabase
        .from("articulos")
        .select("id, titulo, fecha_publicacion, portada")
        .eq("destacado", true)
        .lte("fecha_publicacion", new Date().toISOString())
        .order("fecha_publicacion", { ascending: false })
        .limit(1);

      let noticiaDestacada = noticiaDestacadaData?.[0] || null;

      // 2. Si no hay noticia destacada, obtener la última noticia publicada
      if (!noticiaDestacada) {
        const { data: ultimaNoticiaData } = await supabase
          .from("articulos")
          .select("id, titulo, fecha_publicacion, portada")
          .lte("fecha_publicacion", new Date().toISOString())
          .order("fecha_publicacion", { ascending: false })
          .limit(1);

        noticiaDestacada = ultimaNoticiaData?.[0] || null;
      }

      setNoticiaDestacada(noticiaDestacada);

      // 3. Obtener otras noticias (excluyendo la destacada si existe)
      let noticiasData = [];
      let total = 0;

      if (noticiaDestacada) {
        const { data, count } = await supabase
          .from("articulos")
          .select("id, titulo, fecha_publicacion, portada", { count: "exact" })
          .neq("id", noticiaDestacada.id)
          .lte("fecha_publicacion", new Date().toISOString())
          .order("fecha_publicacion", { ascending: false })
          .range(from, to);
        noticiasData = data || [];
        total = count || 0;
      } else {
        // Si no hay ninguna noticia destacada ni publicada, trae todas las noticias por fecha
        const { data, count } = await supabase
          .from("articulos")
          .select("id, titulo, fecha_publicacion, portada", { count: "exact" })
          .lte("fecha_publicacion", new Date().toISOString())
          .order("fecha_publicacion", { ascending: false })
          .range(from, to);
        noticiasData = data || [];
        total = count || 0;
      }

      setNoticias(noticiasData);
      setTotalNoticias(total);

      // 4. Recomendaciones
      const { data: recomendacionesData } = await supabase
        .from("articulos")
        .select("id, titulo, fecha_publicacion, portada")
        .eq("es_recomendacion", true)
        .lte("fecha_publicacion", new Date().toISOString())
        .order("fecha_publicacion", { ascending: false });

      setRecomendaciones(recomendacionesData || []);
      setCargando(false);
    };

    fetchData(pagina);
  }, [
    pagina,
    setCargando,
    setNoticias,
    setRecomendaciones,
    setNoticiaDestacada,
    setTotalNoticias,
    noticias.length,
    recomendaciones.length,
    noticiaDestacada,
    totalNoticias,
  ]);

  const handleDetalle = (id) => {
    setLoadingDetalle(true);
    setLoadingDetalle(false);
    navigate(`/boletin/${id}`);
  };

  function formatearFecha(fecha) {
    const opciones = { day: "numeric", month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    // Reemplaza "de 2025" por "del 2025"
    return `Fecha de publicación ${fechaFormateada.replace(
      / de (\d{4})$/,
      " del $1"
    )}`;
  }

  if (cargando) {
    return (
      <div className="boletin-container">
        <div className="boletin-content">
          <div className="boletin-main">
            <div className="skeleton-noticia-destacada shimmer"></div>
            <div className="skeleton-otras-noticias">
              <div className="skeleton-noticia-mini shimmer"></div>
              <div className="skeleton-noticia-mini shimmer"></div>
            </div>
          </div>
          <aside className="boletin-sidebar">
            <div className="skeleton-recomendacion shimmer"></div>
            <div className="skeleton-recomendacion shimmer"></div>
          </aside>
        </div>
      </div>
    );
  }

  if (!noticiaDestacada) {
    return <div>No hay noticia destacada.</div>;
  }

  if (!noticias.length) {
    return <div>No se encontraron noticias.</div>;
  }

  return (
    <div className="boletin-container">
      <div className="boletin-content">
        <div className="boletin-main">
          <h2 className="section-title">Noticias Recientes</h2>
          {/* Noticia destacada */}
          <Link
            to={`/boletin/${noticiaDestacada.id}`}
            className="noticia-destacada-link"
            style={{ textDecoration: "none" }}
          >
            <div className="noticia-destacada">
              <img
                src={noticiaDestacada.portada}
                alt={noticiaDestacada.titulo}
                className="noticia-destacada-img"
              />
              <div className="noticia-destacada-info">
                <h3 className="noticia-titulo-link">
                  {noticiaDestacada.titulo}
                </h3>
                <div className="noticia-meta">
                  {formatearFecha(noticiaDestacada.fecha_publicacion)}
                </div>
              </div>
            </div>
          </Link>
          {/* Otras noticias */}
          <div className="otras-noticias">
            {noticias.map((noticia) => (
              <div
                key={noticia.id}
                className="noticia-mini-link"
                style={{ textDecoration: "none", cursor: "pointer" }}
                onClick={() => handleDetalle(noticia.id)}
              >
                <div className="noticia-mini">
                  <img
                    src={noticia.portada}
                    alt={noticia.titulo}
                    className="noticia-mini-img"
                  />
                  <div className="noticia-mini-info">
                    <h4 className="noticia-titulo-link">{noticia.titulo}</h4>
                    <div className="noticia-meta">
                      {formatearFecha(noticia.fecha_publicacion)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* Paginación solo si hay más de 10 noticias */}
          {totalNoticias > pageSize && (
            <div className="paginacion">
              <button
                onClick={() => setPagina((p) => Math.max(1, p - 1))}
                disabled={pagina === 1}
              >
                Anterior
              </button>
              <span>Página {pagina}</span>
              <button
                onClick={() => setPagina((p) => p + 1)}
                disabled={noticias.length < pageSize}
              >
                Siguiente
              </button>
            </div>
          )}
        </div>
        <aside className="boletin-sidebar">
          <h3 className="section-title">Recomendaciones</h3>
          <div className="recomendaciones-grid">
            {recomendaciones.map((rec) => (
              <Link
                key={rec.id}
                to={`/boletin/${rec.id}`}
                className="recomendacion-card-link"
                style={{ textDecoration: "none" }}
              >
                <div className="recomendacion-card">
                  <img
                    src={rec.portada}
                    alt={rec.titulo}
                    className="recomendacion-img"
                  />
                  <div className="recomendacion-info">
                    <h4 className="noticia-titulo-link">{rec.titulo}</h4>
                    <div className="noticia-meta">
                      {formatearFecha(rec.fecha_publicacion)}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}
